"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageFileTypeToJSON = exports.ImageFileTypeFromJSONTyped = exports.ImageFileTypeFromJSON = exports.ImageFileType = void 0;
/**
 * The file type of the image asset as defined by the 'file type' specification of the ISO base media file format standard.
 * @export
 */
exports.ImageFileType = {
    Jpeg: 'JPEG',
    Png: 'PNG'
};
function ImageFileTypeFromJSON(json) {
    return ImageFileTypeFromJSONTyped(json, false);
}
exports.ImageFileTypeFromJSON = ImageFileTypeFromJSON;
function ImageFileTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ImageFileTypeFromJSONTyped = ImageFileTypeFromJSONTyped;
function ImageFileTypeToJSON(value) {
    return value;
}
exports.ImageFileTypeToJSON = ImageFileTypeToJSON;
